document.addEventListener('DOMContentLoaded', function() {
    // 1. Wait for the Shopify variant component to exist
    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    // 2. Identify the fieldsets (Size vs Region)
    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset.product-form__input'));
    if (fieldsets.length < 2) return;

    // Dynamically map fieldsets based on their label text
    let sizeFieldset = fieldsets.find(fs => fs.textContent.toLowerCase().includes('size') || fs.textContent.toLowerCase().includes('quarter')) || fieldsets[0];
    let regionFieldset = fieldsets.find(fs => fs.textContent.toLowerCase().includes('region') || fs.textContent.toLowerCase().includes('punjab')) || fieldsets[1];

    const regionRadios = regionFieldset.querySelectorAll('input[type="radio"]');
    const sizeRadios = sizeFieldset.querySelectorAll('input[type="radio"]');

    let isRealUserClick = false;

    // 3. Prevent auto-selection by blocking the 'checked' property
    regionRadios.forEach(radio => {
      const originalDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
      Object.defineProperty(radio, 'checked', {
        get: function() { return originalDescriptor.get.call(this); },
        set: function(value) {
          if (value === true && !isRealUserClick) return; // Block script-driven selection
          originalDescriptor.set.call(this, value);
        }
      });
    });

    // 4. Handle actual user interactions
    variantSelects.addEventListener('click', (e) => {
      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'LABEL') return;
      isRealUserClick = true;

      // Logic: If Region is clicked, auto-select first Size if empty
      if (regionFieldset.contains(e.target)) {
        const isSizeSelected = Array.from(sizeRadios).some(r => r.checked);
        if (!isSizeSelected && sizeRadios.length > 0) {
          sizeRadios[0].checked = true;
          sizeRadios[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      setTimeout(() => { isRealUserClick = false; }, 100);
    }, true);

    // 5. Intercept events to stop Shopify's internal auto-calculator
    sizeFieldset.addEventListener('change', (e) => {
      const isRegionSelected = Array.from(regionRadios).some(r => r.checked);
      if (!isRegionSelected) {
        // If Region isn't selected yet, stop the propagation
        // This prevents the theme from performing calculations on a partial selection
        e.stopImmediatePropagation();
      }
    }, true);
});